import { i as e, r as t } from "./dist-Br5ou0bD.js";
import { A as n, C as r, D as i, E as a, F as o, I as s, M as c, N as l, O as u, P as d, S as f, T as p, _ as m, a as h, b as g, c as _, d as v, f as y, g as b, h as x, i as S, j as C, k as w, l as T, m as ee, n as E, o as D, p as O, r as k, s as A, t as j, u as M, v as N, w as P, x as F, y as I } from "./useGenericEcommerceService-OQEhFFUo.js";
import { z as L } from "zod";
//#region src/generated/schemas.gen.ts
var R = {
	type: "object",
	properties: {
		city: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The city of the address."
		},
		countryCode: {
			type: "string",
			minLength: 2,
			maxLength: 2,
			pattern: "[A-Z]{2}",
			description: "ISO 3166-1 alpha-2 country code."
		},
		street: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The street of the address."
		},
		additionalInformation: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "Additional information about the address."
		},
		boxNumber: {
			type: "string",
			minLength: 1,
			maxLength: 20,
			description: "The box number of the address, only applicable for specific country codes."
		},
		houseNumber: {
			type: "string",
			minLength: 1,
			maxLength: 25,
			description: "The house number of the address."
		},
		houseNumberSuffix: {
			type: "string",
			minLength: 1,
			maxLength: 25,
			description: "The house number suffix of the address."
		},
		postalCode: {
			type: "string",
			minLength: 1,
			maxLength: 15,
			description: "The postal code of the address."
		},
		region: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The region of the address."
		},
		state: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The state of the address."
		}
	},
	required: [
		"city",
		"countryCode",
		"street"
	],
	description: "A physical address."
}, z = {
	type: "object",
	properties: {
		height: {
			type: "object",
			properties: {
				unit: {
					type: "string",
					enum: [
						"mm",
						"cm",
						"m"
					],
					description: "The unit of measurement for length, width, or height."
				},
				value: {
					type: "integer",
					minimum: 1,
					maximum: 1e6,
					description: "The dimension value."
				}
			},
			required: ["unit", "value"],
			description: "The height."
		},
		length: {
			type: "object",
			properties: {
				unit: {
					type: "string",
					enum: [
						"mm",
						"cm",
						"m"
					],
					description: "The unit of measurement for length, width, or height."
				},
				value: {
					type: "integer",
					minimum: 1,
					maximum: 1e6,
					description: "The dimension value."
				}
			},
			required: ["unit", "value"],
			description: "The length."
		},
		weight: {
			type: "object",
			properties: {
				unit: {
					type: "string",
					enum: ["g", "kg"],
					description: "The unit of weight."
				},
				value: {
					type: "integer",
					minimum: 1,
					maximum: 999999999
				}
			},
			required: ["unit", "value"],
			description: "The weight."
		},
		width: {
			type: "object",
			properties: {
				unit: {
					type: "string",
					enum: [
						"mm",
						"cm",
						"m"
					],
					description: "The unit of measurement for length, width, or height."
				},
				value: {
					type: "integer",
					minimum: 1,
					maximum: 1e6,
					description: "The dimension value."
				}
			},
			required: ["unit", "value"],
			description: "The width."
		}
	},
	description: "The physical dimensions."
}, B = {
	type: "object",
	properties: {
		currency: {
			type: "string",
			minLength: 3,
			maxLength: 3,
			description: "ISO 4217 three-letter currency code."
		},
		micros: {
			type: "integer",
			minimum: 0,
			maximum: 9007199254740991,
			description: "The amount of money in integer micros."
		}
	},
	required: ["currency", "micros"],
	description: "A monetary value represented by split integral and fractional parts to avoid floating point errors."
}, V = {
	type: "object",
	properties: {
		currency: {
			type: "string",
			minLength: 3,
			maxLength: 3,
			description: "ISO 4217 three-letter currency code."
		},
		micros: {
			type: "integer",
			minimum: 0,
			maximum: 9007199254740991,
			description: "The amount of money in integer micros."
		},
		taxRate: {
			type: "integer",
			minimum: 0,
			maximum: 100
		}
	},
	required: [
		"currency",
		"micros",
		"taxRate"
	],
	description: "A monetary value represented by split integral and fractional parts to avoid floating point errors."
}, H = {
	type: "object",
	properties: {
		address: { $ref: "#/components/schemas/Address" },
		contact: {
			oneOf: [{
				type: "object",
				properties: {
					emailAddress: {
						type: "string",
						minLength: 1,
						maxLength: 320,
						description: "An email address."
					},
					locale: {
						anyOf: [{
							type: "string",
							minLength: 5,
							maxLength: 5,
							description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen."
						}, {
							type: "string",
							minLength: 2,
							maxLength: 2,
							description: "ISO 639-1 language code."
						}],
						description: "A value that is either a full locale or just a language code."
					},
					phoneNumber: {
						type: "string",
						minLength: 1,
						maxLength: 50,
						description: "The phone number of the contact."
					},
					type: {
						type: "string",
						enum: ["BUSINESS"],
						description: "Discriminator for business contacts."
					},
					company: {
						type: "string",
						minLength: 1,
						maxLength: 100,
						description: "The name of the company."
					},
					attention: {
						type: "string",
						minLength: 1,
						maxLength: 100,
						description: "The name of the contact person."
					},
					vatNumbersByCountry: {
						type: "object",
						additionalProperties: {
							type: "string",
							minLength: 1,
							maxLength: 20,
							description: "The VAT registration number for the given country."
						},
						description: "A collection of VAT registration numbers of the company, indexed by ISO country code."
					},
					voecNumber: {
						type: "string",
						minLength: 1,
						maxLength: 20,
						description: "The VOEC number of the company."
					},
					eoriNumber: {
						type: "string",
						minLength: 1,
						maxLength: 20,
						description: "The EORI number of the company."
					}
				},
				required: ["type", "company"]
			}, {
				type: "object",
				properties: {
					emailAddress: {
						type: "string",
						minLength: 1,
						maxLength: 320,
						description: "An email address."
					},
					locale: {
						anyOf: [{
							type: "string",
							minLength: 5,
							maxLength: 5,
							description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen."
						}, {
							type: "string",
							minLength: 2,
							maxLength: 2,
							description: "ISO 639-1 language code."
						}],
						description: "A value that is either a full locale or just a language code."
					},
					phoneNumber: {
						type: "string",
						minLength: 1,
						maxLength: 50,
						description: "The phone number of the contact."
					},
					type: {
						type: "string",
						enum: ["PRIVATE"],
						description: "Discriminator for private contacts."
					},
					name: {
						type: "string",
						minLength: 1,
						maxLength: 200,
						description: "The name of the contact person."
					}
				},
				required: ["type", "name"]
			}],
			description: "A contact."
		}
	}
}, U = {
	type: "object",
	properties: {
		carrier: {
			type: "string",
			enum: [
				"BPOST",
				"BRT",
				"CHEAP_CARGO",
				"DHL_EUROPLUS",
				"DHL_FOR_YOU",
				"DHL_PARCEL_CONNECT",
				"DPD",
				"GLS",
				"INPOST",
				"POSTNL",
				"POSTE_ITALIANE",
				"TRUNKRS",
				"UPS_EXPRESS_SAVER",
				"UPS_STANDARD",
				"VIA_TIM"
			],
			description: "The carrier to select to ship a package with."
		},
		customContractId: {
			type: "string",
			minLength: 1,
			maxLength: 50,
			description: "The unique identifier of the contract."
		},
		customsDeclaration: {
			type: "object",
			properties: {
				groups: {
					type: "array",
					items: {
						type: "object",
						properties: {
							description: {
								type: "string",
								minLength: 1,
								maxLength: 50,
								description: "A clear and detailed description of the goods within this group."
							},
							hsCode: {
								type: "string",
								minLength: 6,
								maxLength: 12,
								description: "The Harmonized System (HS) code for the goods in this group, a globally recognized classification for traded products."
							},
							numberOfItems: {
								type: "integer",
								minimum: 1,
								maximum: 99999,
								description: "The total quantity of individual items within this specific group."
							},
							totalValue: {
								type: "object",
								properties: {
									currency: {
										type: "string",
										minLength: 3,
										maxLength: 3,
										description: "ISO 4217 three-letter currency code."
									},
									micros: {
										type: "integer",
										minimum: 0,
										maximum: 9007199254740991,
										description: "The amount of money in integer micros."
									}
								},
								required: ["currency", "micros"],
								description: "The total declared value of all items within this group."
							},
							totalWeight: {
								type: "object",
								properties: {
									unit: {
										type: "string",
										enum: ["g", "kg"],
										description: "The unit of weight."
									},
									value: {
										type: "integer",
										minimum: 1,
										maximum: 999999999
									}
								},
								required: ["unit", "value"],
								description: "The total weight of all items within this specific group."
							},
							countryCodeOfOrigin: {
								type: "string",
								minLength: 2,
								maxLength: 2,
								pattern: "[A-Z]{2}",
								description: "The ISO 3166-1 alpha-2 country code indicating where the goods in this group originated."
							}
						},
						required: [
							"description",
							"hsCode",
							"numberOfItems",
							"totalValue",
							"totalWeight"
						],
						description: "A consolidated group of items within a customs declaration that share common customs attributes."
					},
					minItems: 1,
					maxItems: 100,
					description: "The list of item groups."
				},
				purpose: {
					type: "string",
					enum: [
						"COMMERCIAL_GOODS",
						"COMMERCIAL_SAMPLE",
						"DOCUMENTS",
						"GIFT",
						"RETURNED_GOODS"
					],
					description: "The primary reason or purpose for the international shipment."
				},
				totalWeight: {
					type: "object",
					properties: {
						unit: {
							type: "string",
							enum: ["g", "kg"],
							description: "The unit of weight."
						},
						value: {
							type: "integer",
							minimum: 1,
							maximum: 999999999
						}
					},
					required: ["unit", "value"],
					description: "The total weight of all items declared within this customs declaration."
				},
				invoiceNumber: {
					type: "string",
					minLength: 1,
					maxLength: 150,
					description: "The identifying number of the commercial invoice associated with this shipment."
				}
			},
			required: [
				"groups",
				"purpose",
				"totalWeight"
			],
			description: "The official declaration of goods for customs clearance purposes during international shipment."
		},
		delivery: {
			type: "object",
			properties: {
				options: {
					type: "object",
					properties: {
						notifyOnDelivery: {
							type: "object",
							additionalProperties: !1,
							description: "Notify sender upon package delivery."
						},
						preferredDate: {
							type: "object",
							properties: { date: {
								type: "string",
								format: "date",
								description: "Recipient specified preferred delivery date."
							} },
							required: ["date"],
							description: "This option allows you to set a preferred date for delivery, so a drop off date can be calculated."
						}
					},
					description: "Options regarding delivery timing and notifications."
				},
				type: {
					type: "string",
					enum: [
						"EARLY_MORNING_DELIVERY",
						"EVENING_DELIVERY",
						"EXPRESS_DELIVERY",
						"MORNING_DELIVERY",
						"PICKUP_EXPRESS_DELIVERY",
						"PICKUP_DELIVERY",
						"SAME_DAY_DELIVERY",
						"STANDARD_DELIVERY"
					],
					description: "The delivery type of the shipment."
				}
			},
			description: "The delivery details of the shipment."
		},
		direction: {
			type: "string",
			enum: ["OUTBOUND", "INBOUND"],
			description: "The direction of the shipment. OUTBOUND is from sender to recipient, INBOUND is from recipient to sender."
		},
		disableAutoDetectPickup: {
			type: "boolean",
			description: "When set to true, this field disables the automatic detection and change of a recipient's address to a pickup location, particularly when the recipient's address is very close to or within the same building as a pickup point."
		},
		numberOfLabels: {
			type: "integer",
			minimum: 1,
			maximum: 20
		},
		options: {
			type: "object",
			properties: {
				additionalInsurance: {
					type: "object",
					additionalProperties: !1,
					description: "Provides enhanced insurance coverage beyond the standard amount."
				},
				deliverAtPostalPoint: {
					type: "object",
					additionalProperties: !1,
					description: "Indicates that the parcel will be delivered to a designated postal service point rather than the recipient's address, requiring the recipient to collect it from that location."
				},
				freshFood: {
					type: "object",
					additionalProperties: !1,
					description: "Designates the shipment as containing perishable, non-frozen food items, ensuring appropriate handling procedures are applied to maintain freshness and prevent spoilage during transit."
				},
				frozen: {
					type: "object",
					additionalProperties: !1,
					description: "Specifies that the shipment contains items that must remain frozen, necessitating strict, continuous temperature-controlled environments throughout the transit process to prevent thawing."
				},
				hideSender: {
					type: "object",
					additionalProperties: !1,
					description: "Omits the sender's information from the shipping label, maintaining sender anonymity in the delivery process."
				},
				insurance: {
					type: "object",
					properties: { amount: {
						type: "object",
						properties: {
							currency: {
								type: "string",
								minLength: 3,
								maxLength: 3,
								description: "ISO 4217 three-letter currency code."
							},
							micros: {
								type: "integer",
								minimum: 0,
								maximum: 9007199254740991,
								description: "The amount of money in integer micros."
							}
						},
						required: ["currency", "micros"],
						description: "The amount to insure."
					} },
					required: ["amount"],
					description: "Provides standard insurance coverage up to the specified monetary amount."
				},
				noTracking: {
					type: "object",
					additionalProperties: !1,
					description: "Disables all tracking and tracing capabilities for the shipment."
				},
				oversizedPackage: {
					type: "object",
					additionalProperties: !1,
					description: "Designates the shipment as exceeding standard size limitations, requiring special handling procedures and potentially incurring additional fees."
				},
				printReturnLabelAtDropOff: {
					type: "object",
					additionalProperties: !1,
					description: "Provides the recipient with a digital identifier that can be presented at a drop-off location to print the return label on-site. This option is only applicable for inbound shipments."
				},
				priorityDelivery: {
					type: "object",
					additionalProperties: !1,
					description: "Designates the shipment for expedited processing and transport through the delivery network, often resulting in a faster transit time compared to standard services."
				},
				recipientOnlyDelivery: {
					type: "object",
					additionalProperties: !1,
					description: "Restricts delivery exclusively to the named recipient, requiring verification of recipient identity and prohibiting delivery to anyone else at the same address."
				},
				requiresAgeVerification: {
					type: "object",
					additionalProperties: !1,
					description: "Requires the recipient to provide valid identification to verify they meet the minimum age requirement before the package can be released, typically used for age-restricted items."
				},
				requiresCashOnDelivery: {
					type: "object",
					additionalProperties: !1,
					description: "Mandates that the carrier collect the full order amount in cash from the recipient upon delivery, ensuring payment is secured before the goods are handed over."
				},
				requiresReceiptCode: {
					type: "object",
					additionalProperties: !1,
					description: "Requires the recipient to provide a specific verification code at the time of delivery, adding an extra layer of security and confirmation for sensitive shipments."
				},
				requiresSignature: {
					type: "object",
					additionalProperties: !1,
					description: "Mandates that the recipient or authorized representative must provide a signature upon delivery, creating proof of receipt and transfer of responsibility."
				},
				returnContributionFee: {
					type: "object",
					properties: { amount: {
						type: "object",
						properties: {
							currency: {
								type: "string",
								minLength: 3,
								maxLength: 3,
								description: "ISO 4217 three-letter currency code."
							},
							micros: {
								type: "integer",
								minimum: 0,
								maximum: 9007199254740991,
								description: "The amount of money in integer micros."
							}
						},
						required: ["currency", "micros"],
						description: "The amount of the contribution."
					} },
					required: ["amount"],
					description: "Specifies that the recipient must pay the designated contribution amount toward the cost of returning the item. This option is only applicable for inbound shipments."
				},
				returnOnFirstFailedDelivery: {
					type: "object",
					additionalProperties: !1,
					description: "Instructs the carrier to return the package to the sender immediately after the first unsuccessful delivery attempt, bypassing the standard redelivery procedures or holding period."
				},
				sameDayDelivery: {
					type: "object",
					additionalProperties: !1,
					description: "Expedited delivery within the same calendar day that the shipping label is created."
				},
				saturdayDelivery: {
					type: "object",
					additionalProperties: !1,
					description: "Enables delivery on Saturday, which is typically outside standard delivery days, ensuring the package arrives before the start of the following work week."
				},
				scheduledCollection: {
					type: "object",
					additionalProperties: !1,
					description: "Arranges for the carrier to pick up the package from the sender's location, eliminating the need for the sender to drop off the package."
				},
				customLabelText: {
					type: "object",
					properties: { text: {
						type: "string",
						minLength: 1,
						maxLength: 45,
						description: "Allows adding personalized text to be printed on the shipping label, which can include special handling instructions or reference information."
					} },
					required: ["text"],
					description: "Defines a custom text to be printed on the shipping label."
				}
			},
			description: "The complete set of shipment options."
		},
		packageType: {
			type: "string",
			enum: [
				"DIGITAL_STAMP",
				"ENVELOPE",
				"MAILBOX",
				"PACKAGE",
				"PALLET",
				"SMALL_PACKAGE",
				"UNFRANKED"
			],
			description: "The type of the package."
		},
		pickup: {
			anyOf: [
				{
					type: "object",
					properties: {
						address: {
							type: "object",
							properties: {
								city: {
									type: "string",
									minLength: 1,
									maxLength: 100,
									description: "The city of the address."
								},
								countryCode: {
									type: "string",
									minLength: 2,
									maxLength: 2,
									pattern: "[A-Z]{2}",
									description: "ISO 3166-1 alpha-2 country code."
								},
								street: {
									type: "string",
									minLength: 1,
									maxLength: 100,
									description: "The street of the address."
								},
								additionalInformation: {
									type: "string",
									minLength: 1,
									maxLength: 100,
									description: "Additional information about the address."
								},
								boxNumber: {
									type: "string",
									minLength: 1,
									maxLength: 20,
									description: "The box number of the address, only applicable for specific country codes."
								},
								houseNumber: {
									type: "string",
									minLength: 1,
									maxLength: 25,
									description: "The house number of the address."
								},
								houseNumberSuffix: {
									type: "string",
									minLength: 1,
									maxLength: 25,
									description: "The house number suffix of the address."
								},
								postalCode: {
									type: "string",
									minLength: 1,
									maxLength: 15,
									description: "The postal code of the address."
								},
								region: {
									type: "string",
									minLength: 1,
									maxLength: 100,
									description: "The region of the address."
								},
								state: {
									type: "string",
									minLength: 1,
									maxLength: 100,
									description: "The state of the address."
								}
							},
							required: [
								"city",
								"countryCode",
								"street"
							],
							description: "The address of the pickup location."
						},
						location: {
							type: "object",
							properties: {
								name: {
									type: "string",
									minLength: 1,
									maxLength: 200,
									description: "The name of the pickup location."
								},
								code: {
									type: "string",
									minLength: 1,
									maxLength: 64,
									description: "The location code of the pickup location."
								},
								type: {
									type: "string",
									enum: [
										"CLICK_COLLECT",
										"PARCEL_LOCKER",
										"PARCEL_POINT",
										"POST_OFFICE",
										"POST_POINT"
									],
									description: "The bpost pickup location type."
								}
							},
							required: ["name", "type"],
							description: "The pickup location details."
						}
					},
					required: ["address", "location"],
					description: "The bpost pickup details."
				},
				{
					type: "object",
					properties: {
						address: {
							type: "object",
							properties: {
								city: {
									type: "string",
									minLength: 1,
									maxLength: 100,
									description: "The city of the address."
								},
								countryCode: {
									type: "string",
									minLength: 2,
									maxLength: 2,
									pattern: "[A-Z]{2}",
									description: "ISO 3166-1 alpha-2 country code."
								},
								street: {
									type: "string",
									minLength: 1,
									maxLength: 100,
									description: "The street of the address."
								},
								additionalInformation: {
									type: "string",
									minLength: 1,
									maxLength: 100,
									description: "Additional information about the address."
								},
								boxNumber: {
									type: "string",
									minLength: 1,
									maxLength: 20,
									description: "The box number of the address, only applicable for specific country codes."
								},
								houseNumber: {
									type: "string",
									minLength: 1,
									maxLength: 25,
									description: "The house number of the address."
								},
								houseNumberSuffix: {
									type: "string",
									minLength: 1,
									maxLength: 25,
									description: "The house number suffix of the address."
								},
								postalCode: {
									type: "string",
									minLength: 1,
									maxLength: 15,
									description: "The postal code of the address."
								},
								region: {
									type: "string",
									minLength: 1,
									maxLength: 100,
									description: "The region of the address."
								},
								state: {
									type: "string",
									minLength: 1,
									maxLength: 100,
									description: "The state of the address."
								}
							},
							required: [
								"city",
								"countryCode",
								"street"
							],
							description: "The address of the pickup location."
						},
						location: {
							type: "object",
							properties: {
								name: {
									type: "string",
									minLength: 1,
									maxLength: 200,
									description: "The name of the pickup location."
								},
								code: {
									type: "string",
									minLength: 1,
									maxLength: 64,
									description: "The location code of the pickup location."
								}
							},
							required: ["name"],
							description: "The pickup location details."
						},
						retailNetworkId: {
							type: "string",
							enum: ["PNPNL-01", "PNPBE-01"],
							description: "PostNL Retail network ID."
						}
					},
					required: [
						"address",
						"location",
						"retailNetworkId"
					],
					description: "The PostNL pickup details."
				},
				{
					type: "object",
					properties: {
						address: {
							type: "object",
							properties: {
								city: {
									type: "string",
									minLength: 1,
									maxLength: 100,
									description: "The city of the address."
								},
								countryCode: {
									type: "string",
									minLength: 2,
									maxLength: 2,
									pattern: "[A-Z]{2}",
									description: "ISO 3166-1 alpha-2 country code."
								},
								street: {
									type: "string",
									minLength: 1,
									maxLength: 100,
									description: "The street of the address."
								},
								additionalInformation: {
									type: "string",
									minLength: 1,
									maxLength: 100,
									description: "Additional information about the address."
								},
								boxNumber: {
									type: "string",
									minLength: 1,
									maxLength: 20,
									description: "The box number of the address, only applicable for specific country codes."
								},
								houseNumber: {
									type: "string",
									minLength: 1,
									maxLength: 25,
									description: "The house number of the address."
								},
								houseNumberSuffix: {
									type: "string",
									minLength: 1,
									maxLength: 25,
									description: "The house number suffix of the address."
								},
								postalCode: {
									type: "string",
									minLength: 1,
									maxLength: 15,
									description: "The postal code of the address."
								},
								region: {
									type: "string",
									minLength: 1,
									maxLength: 100,
									description: "The region of the address."
								},
								state: {
									type: "string",
									minLength: 1,
									maxLength: 100,
									description: "The state of the address."
								}
							},
							required: [
								"city",
								"countryCode",
								"street"
							],
							description: "The address of the pickup location."
						},
						location: {
							type: "object",
							properties: {
								name: {
									type: "string",
									minLength: 1,
									maxLength: 200,
									description: "The name of the pickup location."
								},
								code: {
									type: "string",
									minLength: 1,
									maxLength: 64,
									description: "The location code of the pickup location."
								}
							},
							required: ["name"],
							description: "The pickup location details."
						}
					},
					required: ["address", "location"],
					description: "The general pickup details."
				}
			],
			description: "The pickup details."
		},
		recipient: {
			type: "object",
			properties: {
				address: {
					type: "object",
					properties: {
						city: {
							type: "string",
							minLength: 1,
							maxLength: 100,
							description: "The city of the address."
						},
						countryCode: {
							type: "string",
							minLength: 2,
							maxLength: 2,
							pattern: "[A-Z]{2}",
							description: "ISO 3166-1 alpha-2 country code."
						},
						street: {
							type: "string",
							minLength: 1,
							maxLength: 100,
							description: "The street of the address."
						},
						additionalInformation: {
							type: "string",
							minLength: 1,
							maxLength: 100,
							description: "Additional information about the address."
						},
						boxNumber: {
							type: "string",
							minLength: 1,
							maxLength: 20,
							description: "The box number of the address, only applicable for specific country codes."
						},
						houseNumber: {
							type: "string",
							minLength: 1,
							maxLength: 25,
							description: "The house number of the address."
						},
						houseNumberSuffix: {
							type: "string",
							minLength: 1,
							maxLength: 25,
							description: "The house number suffix of the address."
						},
						postalCode: {
							type: "string",
							minLength: 1,
							maxLength: 15,
							description: "The postal code of the address."
						},
						region: {
							type: "string",
							minLength: 1,
							maxLength: 100,
							description: "The region of the address."
						},
						state: {
							type: "string",
							minLength: 1,
							maxLength: 100,
							description: "The state of the address."
						}
					},
					required: [
						"city",
						"countryCode",
						"street"
					],
					description: "The address of the recipient."
				},
				contact: {
					oneOf: [{
						type: "object",
						properties: {
							locale: {
								anyOf: [{
									type: "string",
									minLength: 5,
									maxLength: 5,
									description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen."
								}, {
									type: "string",
									minLength: 2,
									maxLength: 2,
									description: "ISO 639-1 language code."
								}],
								description: "A value that is either a full locale or just a language code."
							},
							phoneNumber: {
								type: "string",
								minLength: 1,
								maxLength: 50,
								description: "The phone number of the contact."
							},
							type: {
								type: "string",
								enum: ["BUSINESS"],
								description: "Discriminator for business contacts."
							},
							company: {
								type: "string",
								minLength: 1,
								maxLength: 100,
								description: "The name of the company."
							},
							attention: {
								type: "string",
								minLength: 1,
								maxLength: 100,
								description: "The name of the contact person."
							},
							vatNumbersByCountry: {
								type: "object",
								additionalProperties: {
									type: "string",
									minLength: 1,
									maxLength: 20,
									description: "The VAT registration number for the given country."
								},
								description: "A collection of VAT registration numbers of the company, indexed by ISO country code."
							},
							voecNumber: {
								type: "string",
								minLength: 1,
								maxLength: 20,
								description: "The VOEC number of the company."
							},
							eoriNumber: {
								type: "string",
								minLength: 1,
								maxLength: 20,
								description: "The EORI number of the company."
							},
							emailAddresses: {
								type: "array",
								items: {
									type: "string",
									minLength: 1,
									maxLength: 320,
									description: "An email address."
								},
								minItems: 1,
								maxItems: 5,
								description: "The email addresses of the contact. The first email address will be used as the primary email address. The remaining will be used as extra email addresses if the right permissions are present."
							}
						},
						required: ["type", "company"],
						description: "A business contact that supports multiple email addresses."
					}, {
						type: "object",
						properties: {
							locale: {
								anyOf: [{
									type: "string",
									minLength: 5,
									maxLength: 5,
									description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen."
								}, {
									type: "string",
									minLength: 2,
									maxLength: 2,
									description: "ISO 639-1 language code."
								}],
								description: "A value that is either a full locale or just a language code."
							},
							phoneNumber: {
								type: "string",
								minLength: 1,
								maxLength: 50,
								description: "The phone number of the contact."
							},
							type: {
								type: "string",
								enum: ["PRIVATE"],
								description: "Discriminator for private contacts."
							},
							name: {
								type: "string",
								minLength: 1,
								maxLength: 200,
								description: "The name of the contact person."
							},
							emailAddresses: {
								type: "array",
								items: {
									type: "string",
									minLength: 1,
									maxLength: 320,
									description: "An email address."
								},
								minItems: 1,
								maxItems: 5,
								description: "The email addresses of the contact. The first email address will be used as the primary email address. The remaining will be used as extra email addresses if the right permissions are present."
							}
						},
						required: ["type", "name"],
						description: "A private contact that supports multiple email addresses."
					}],
					description: "The contact details of the recipient."
				}
			},
			description: "The recipient of the shipment."
		}
	},
	description: "The shipping preferences of the order. This should be used as default information when preparing packages for shipment."
}, W = {
	type: "object",
	properties: {
		barcode: {
			type: "string",
			minLength: 6,
			maxLength: 24
		},
		containsDangerousSubstances: { type: "boolean" },
		countryCodeOfOrigin: {
			type: "string",
			minLength: 2,
			maxLength: 2,
			pattern: "[A-Z]{2}",
			description: "ISO 3166-1 alpha-2 country code."
		},
		descriptions: {
			type: "array",
			items: {
				type: "object",
				properties: {
					text: {
						type: "string",
						minLength: 1,
						maxLength: 2500,
						description: "The text of one of the product descriptions."
					},
					languageCode: {
						type: "string",
						minLength: 2,
						maxLength: 2,
						description: "The language code (ISO 639-1) of one of the product descriptions."
					}
				},
				required: ["text", "languageCode"]
			},
			minItems: 1,
			maxItems: 200,
			description: "The descriptions of the product."
		},
		ean: {
			type: "string",
			minLength: 1,
			maxLength: 13
		},
		fulfilment: {
			type: "object",
			properties: {
				platforms: {
					type: "array",
					items: {
						type: "string",
						enum: ["VASCO"],
						description: "The fulfilment platform."
					},
					minItems: 1
				},
				trackInventory: { type: "boolean" }
			},
			required: ["platforms"]
		},
		hasUnlimitedShelfLife: { type: "boolean" },
		hsCode: {
			type: "string",
			minLength: 6,
			maxLength: 10,
			description: "The HS code of the product."
		},
		name: { type: "string" },
		physicalProperties: { $ref: "#/components/schemas/PhysicalProperties" },
		purchasePrice: { $ref: "#/components/schemas/Money" },
		salesPrice: { $ref: "#/components/schemas/SalesPrice" },
		sku: { type: "string" }
	},
	required: ["name"]
}, G = { allOf: [{ $ref: "#/components/schemas/Product" }, {
	type: "object",
	properties: { sourceId: {
		type: "string",
		minLength: 1,
		maxLength: 50,
		description: "The product ID as defined in the source system."
	} },
	required: ["sourceId"]
}] }, K = {
	type: "object",
	properties: {
		billingDetails: { allOf: [{ $ref: "#/components/schemas/BillingDetails" }, { description: "Billing details of the order." }] },
		customerReference: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The customer reference of the order."
		},
		orderedAt: {
			type: "string",
			format: "date-time",
			description: "An ISO 8601 formatted datetime string with timezone offset."
		},
		shipping: { $ref: "#/components/schemas/ShippingPreferences" },
		sourceId: {
			type: "string",
			minLength: 1,
			maxLength: 50,
			description: "The order ID as defined in the source system."
		}
	},
	required: ["orderedAt", "sourceId"]
}, q = {
	type: "object",
	properties: {
		billingDetails: { allOf: [{ $ref: "#/components/schemas/BillingDetails" }, { description: "Billing details of the order." }] },
		customerReference: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The customer reference of the order."
		},
		orderedAt: {
			type: "string",
			format: "date-time",
			description: "An ISO 8601 formatted datetime string with timezone offset."
		},
		shipping: { $ref: "#/components/schemas/ShippingPreferences" },
		sourceId: {
			type: "string",
			minLength: 1,
			maxLength: 50,
			description: "The order ID as defined in the source system."
		},
		lines: {
			type: "array",
			items: {
				type: "object",
				properties: {
					price: { $ref: "#/components/schemas/Money" },
					product: { $ref: "#/components/schemas/SalesChannelProduct" },
					quantity: {
						type: "integer",
						exclusiveMinimum: 0
					},
					sourceId: {
						type: "string",
						minLength: 1,
						maxLength: 50,
						description: "The line ID as defined in the source system."
					}
				},
				required: [
					"product",
					"quantity",
					"sourceId"
				]
			},
			minItems: 1
		},
		salesChannelId: {
			type: "string",
			format: "uuid"
		}
	},
	required: [
		"orderedAt",
		"sourceId",
		"salesChannelId"
	],
	additionalProperties: !1
}, J = {
	type: "object",
	properties: {
		billingDetails: { allOf: [{ $ref: "#/components/schemas/BillingDetails" }, { description: "Billing details of the order." }] },
		customerReference: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The customer reference of the order."
		},
		orderedAt: {
			type: "string",
			format: "date-time",
			description: "An ISO 8601 formatted datetime string with timezone offset."
		},
		shipping: { $ref: "#/components/schemas/ShippingPreferences" },
		sourceId: {
			type: "string",
			minLength: 1,
			maxLength: 50,
			description: "The order ID as defined in the source system."
		},
		lines: {
			type: "array",
			items: {
				type: "object",
				properties: {
					price: { $ref: "#/components/schemas/Money" },
					product: { $ref: "#/components/schemas/Product" },
					quantity: {
						type: "integer",
						exclusiveMinimum: 0
					}
				},
				required: ["product", "quantity"]
			},
			minItems: 1
		},
		shopId: {
			type: "string",
			minLength: 1,
			maxLength: 50,
			description: "The unique identifier of the shop."
		}
	},
	required: [
		"orderedAt",
		"sourceId",
		"shopId"
	],
	additionalProperties: !1
}, Y = {
	type: "object",
	properties: {
		createdAt: {
			anyOf: [{ type: "string" }, {
				type: "string",
				format: "date-time",
				description: "An ISO 8601 formatted datetime string with timezone offset."
			}],
			description: "Sales channel created at."
		},
		id: {
			type: "string",
			minLength: 1,
			maxLength: 50,
			description: "The sales channel ID."
		},
		name: {
			type: "string",
			minLength: 3,
			maxLength: 50,
			description: "Custom sales channel name."
		},
		shopId: {
			type: "string",
			minLength: 1,
			maxLength: 50,
			description: "Owning shop ID for the sales channel."
		},
		url: {
			type: "string",
			maxLength: 250,
			format: "uri",
			description: "The URL of the sales channel."
		}
	},
	required: [
		"createdAt",
		"id",
		"name",
		"shopId",
		"url"
	]
}, X = {
	type: "object",
	properties: {
		type: {
			type: "string",
			enum: [
				"about:blank",
				"urn:problem:client",
				"urn:problem:invalid-request-syntax",
				"urn:problem:not-found",
				"urn:problem:server",
				"urn:problem:unauthorized",
				"urn:problem:unsupported-media-type"
			],
			description: "A URI reference that identifies the problem type."
		},
		status: {
			type: "integer",
			enum: [
				400,
				401,
				404,
				415,
				500
			],
			description: "The HTTP status code generated by the origin server."
		},
		title: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "A short human-readable summary of the problem type."
		},
		detail: {
			type: "string",
			minLength: 1,
			maxLength: 5e3,
			description: "A human-readable explanation specific to this occurrence of the problem."
		},
		instance: {
			type: "string",
			format: "uri",
			description: "A URI reference that identifies the specific occurrence of the problem."
		},
		cause: { description: "The cause of this problem when debug mode is enabled." }
	},
	required: [
		"type",
		"status",
		"title",
		"detail",
		"instance"
	]
}, Z = { allOf: [{ $ref: "#/components/schemas/ProblemDetails" }, {
	type: "object",
	properties: {
		type: {
			type: "string",
			enum: ["urn:problem:client"],
			description: "A URI reference that identifies the problem type."
		},
		status: {
			type: "number",
			enum: [400],
			description: "The HTTP status code generated by the origin server."
		},
		errors: {
			type: "array",
			items: {
				type: "object",
				properties: {
					detail: {
						type: "string",
						minLength: 1,
						maxLength: 5e3
					},
					pointer: {
						type: "string",
						minLength: 1,
						maxLength: 200,
						description: "This is a JSON pointer to the request (body, parameters, ...). When an aggregate has a conflict (e.g. not allowed due to the status) this value is for bulk request on the index (/body/{index}) and for any other on root (/)."
					}
				},
				required: ["detail", "pointer"]
			},
			minItems: 1,
			description: "Detailed information regarding the violations."
		}
	},
	required: ["errors"]
}] }, Q = { allOf: [{ $ref: "#/components/schemas/ProblemDetails" }, {
	type: "object",
	properties: {
		type: {
			type: "string",
			enum: ["urn:problem:server"],
			description: "A URI reference that identifies the problem type."
		},
		status: {
			type: "number",
			enum: [500],
			description: "The HTTP status code generated by the origin server."
		}
	}
}] }, $ = { allOf: [{ $ref: "#/components/schemas/ProblemDetails" }, {
	type: "object",
	properties: {
		type: {
			type: "string",
			enum: ["urn:problem:invalid-request-syntax"],
			description: "A URI reference that identifies the problem type."
		},
		status: {
			type: "number",
			enum: [400],
			description: "The HTTP status code generated by the origin server."
		},
		errors: {
			type: "array",
			items: {
				type: "object",
				properties: {
					detail: {
						type: "string",
						minLength: 1,
						maxLength: 5e3
					},
					pointer: {
						type: "string",
						minLength: 1,
						maxLength: 200,
						description: "This is a JSON pointer to the request (body, parameters, ...). When an aggregate has a conflict (e.g. not allowed due to the status) this value is for bulk request on the index (/body/{index}) and for any other on root (/)."
					}
				},
				required: ["detail", "pointer"]
			},
			minItems: 1,
			description: "Detailed information regarding the syntactic violations."
		}
	},
	required: ["errors"]
}] }, te = { allOf: [{ $ref: "#/components/schemas/ProblemDetails" }, {
	type: "object",
	properties: {
		type: {
			type: "string",
			enum: ["urn:problem:not-found"],
			description: "A URI reference that identifies the problem type."
		},
		status: {
			type: "number",
			enum: [404],
			description: "The HTTP status code generated by the origin server."
		}
	}
}] }, ne = L.toJSONSchema(m.shape.body).maxItems;
//#endregion
export { R as AddressSchema, K as BaseOrderSchema, H as BillingDetailsSchema, B as MoneySchema, z as PhysicalPropertiesSchema, Z as ProblemDetailsClientSchema, Q as ProblemDetailsInternalServerErrorSchema, $ as ProblemDetailsInvalidRequestSyntaxSchema, te as ProblemDetailsNotFoundSchema, X as ProblemDetailsSchema, W as ProductSchema, q as SalesChannelOrderSchema, G as SalesChannelProductSchema, Y as SalesChannelSchema, V as SalesPriceSchema, U as ShippingPreferencesSchema, J as ShopOrderSchema, t as genericEcommerceAcceptanceApiUrl, e as genericEcommerceApiUrl, E as getSalesChannels, k as getSalesChannelsBySalesChannelId, ne as maxOrdersPerRequest, S as postOrders, h as postRemoveSalesChannel, D as postRenameSalesChannel, A as postSalesChannels, j as useGenericEcommerceService, _ as zAddress, T as zBaseOrder, M as zBillingDetails, v as zGetSalesChannelsBySalesChannelIdData, y as zGetSalesChannelsBySalesChannelIdResponse, O as zGetSalesChannelsData, ee as zGetSalesChannelsResponse, x as zMoney, b as zPhysicalProperties, m as zPostOrdersData, N as zPostOrdersResponse, I as zPostRemoveSalesChannelData, g as zPostRemoveSalesChannelResponse, F as zPostRenameSalesChannelData, f as zPostRenameSalesChannelResponse, r as zPostSalesChannelsData, P as zPostSalesChannelsResponse, p as zProblemDetails, a as zProblemDetailsClient, i as zProblemDetailsInternalServerError, u as zProblemDetailsInvalidRequestSyntax, w as zProblemDetailsNotFound, n as zProduct, C as zSalesChannel, c as zSalesChannelOrder, l as zSalesChannelProduct, d as zSalesPrice, o as zShippingPreferences, s as zShopOrder };
